import { render, staticRenderFns } from "./Teacher3.vue?vue&type=template&id=e29a494e&scoped=true"
import script from "./Teacher3.vue?vue&type=script&lang=js"
export * from "./Teacher3.vue?vue&type=script&lang=js"
import style0 from "./Teacher3.vue?vue&type=style&index=0&id=e29a494e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29a494e",
  null
  
)

export default component.exports